import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import Tooltip from "./Tooltip";
import apiCumbres from "../axios/axios";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useSelector } from 'react-redux';
import { sxTableHead, textFieldStyle } from "./Styles";
import ModalPagosPrestmo from "./ModalPagosPrestamo";
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ModalInfoPrestamoClientes from "./ModalInfoPrestamoClientes";
import ModalPagosPrestamoGrupal from "./ModalPagosPrestamoGrupal";



const RevisarPrestamosGrupal = () => {
    const tkn = useSelector((state) => state.tknAuth)
    const [isLoading, setIsLoading] = useState(false)

    const [prestamos, setPrestamos] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [search, setSearch] = useState("");
    const [modalInfoPrestamoClientes, setModalInfoPrestamoClientes] = useState(false)
    const [modalPpgOpen, setModalPpgOpen] = useState(false)
    const [idPrestamoGrupal, setIdPretamoGrupal] = useState(null)

    const obtenerPrestamosGrupal = () => {

        const prestamosGrupal = async () => {

            try {
                setIsLoading(true)

                const obtener = await apiCumbres.get(`/revisar-prestamos/obtener-grupal/${tkn.usuarioId}`)

                setPrestamos(obtener.data)
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener préstamos para autorizar, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        prestamosGrupal()

    }

    useEffect(() => {
        obtenerPrestamosGrupal()
    }, [])

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate()} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const verAbonosContrato = (e, id) => {
        setIdPretamoGrupal(id)
        setModalPpgOpen(true)

    }


    const verContrato = (e, id, tc) => {

        const contrato = async () => {
            setIsLoading(true)
            try {

                const obtener = await apiCumbres.get(`/revisar-prestamos/contrato/${id}?tp=G&tc=${tc}`)

                //mandar a abrir el pdf

                // Decodificar base64
                const byteCharacters = atob(obtener.data);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);

                // ⚠️ MIME TYPE CORRECTO
                const file = new Blob([byteArray], { type: "application/pdf" });

                // Crear URL
                const fileURL = URL.createObjectURL(file);

                // 👉 Abrir en nueva pestaña
                window.open(fileURL, "_blank");
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener contrato de préstamo, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        contrato()

    }



    const filteredPrestamos = prestamos.filter(pp =>
        pp.clientes
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    const verInformacionClientes = (e, id) => {

        //mostrar modal con los pagos, y si ya se pago o no, con las fechas en una tabla
        setIdPretamoGrupal(id)
        setModalInfoPrestamoClientes(true)

        //hacer template de contrato micro y personal

    }

    return (
        <div className="container">
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="row">
                <div className="col-md-12">
                    <div
                        className="card shadow-lg  p-5 border-0"
                        style={{ borderRadius: '20px' }}
                    >

                        <div className="row">
                            <motion.h1 className="color-primary"
                                initial={{ opacity: 0, y: -90 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                Revisar Préstamos Grupales
                            </motion.h1>
                            <hr className="mb-5" />
                            <motion.div
                                key={page}
                                initial={{ opacity: 0, y: 40 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}

                            >
                                <TextField
                                    label="Buscar prestamo por cliente"
                                    variant="outlined"
                                    size="small"
                                    className="mb-3"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    sx={textFieldStyle}
                                />

                                <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                                    <Table >
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                <TableCell sx={sxTableHead}>#</TableCell>
                                                <TableCell sx={sxTableHead}>Clientes</TableCell>
                                                <TableCell sx={sxTableHead}>Prestamista</TableCell>
                                                <TableCell sx={sxTableHead}>Comienza</TableCell>
                                                <TableCell sx={sxTableHead}>Primer Pago</TableCell>
                                                <TableCell sx={sxTableHead}>Tipo Préstamo</TableCell>
                                                <TableCell sx={sxTableHead}>Tipo Pago</TableCell>
                                                <TableCell sx={sxTableHead}>Estatus</TableCell>
                                                <TableCell sx={sxTableHead}>Meses</TableCell>
                                                <TableCell sx={sxTableHead}>Pagos</TableCell>
                                                <TableCell sx={sxTableHead}>Contrato</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            <AnimatePresence component={null}>
                                                {filteredPrestamos
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pp, index) => (
                                                        <motion.tr
                                                            key={index}
                                                            initial={{ opacity: 0, x: -50 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            exit={{ opacity: 0, y: -40 }}
                                                            transition={{
                                                                duration: 0.4,
                                                                ease: "easeOut",
                                                                delay: 0.1 * index
                                                            }}
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                            }}
                                                        >
                                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                            <TableCell>
                                                                <Tooltip text={'VER INFORMACIÓN DE CLIENTES'} position="bottom">
                                                                    <SupervisedUserCircleIcon fontSize="large" className="pointer" onClick={(e) => verInformacionClientes(e, pp.contratoPrestamoGrupalId)} />
                                                                </Tooltip>
                                                            </TableCell>
                                                            <TableCell>{pp.nombreusuario}</TableCell>
                                                            <TableCell>{formatFecha(pp.fechaComienzaContrato)}</TableCell>
                                                            <TableCell>{formatFecha(pp.fechaPrimerPagoContrato)}</TableCell>
                                                            <TableCell>{pp.tipoPrestamo}</TableCell>
                                                            <TableCell>{pp.tipoPago}</TableCell>
                                                            <TableCell>{pp.estatusPrestamo}</TableCell>
                                                            <TableCell>{pp.meses}</TableCell>
                                                            <TableCell>
                                                                {['EN PROCESO'].includes(pp.estatusPrestamo) ?
                                                                    <Tooltip text={'VER PAGOS'} position="bottom">
                                                                        <RemoveRedEyeIcon className="pointer" onClick={(e) => verAbonosContrato(e, pp.contratoPrestamoGrupalId)} />
                                                                    </Tooltip>
                                                                    : 'N/A'

                                                                }

                                                            </TableCell>
                                                            <TableCell>
                                                                {['LIQUIDADO', 'EN PROCESO'].includes(pp.estatusPrestamo) ?
                                                                    <Tooltip text={'VER CONTRATO'} position="bottom">
                                                                        <RemoveRedEyeIcon className="pointer" onClick={(e) => verContrato(e, pp.contratoPrestamoGrupalId, pp.tipoPrestamo)} />
                                                                    </Tooltip>
                                                                    : 'N/A'

                                                                }

                                                            </TableCell>
                                                        </motion.tr>
                                                    ))}
                                            </AnimatePresence>
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={filteredPrestamos.length}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage="Registros por página"
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                    />
                                </TableContainer>
                            </motion.div>


                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

            <ModalInfoPrestamoClientes
                open={modalInfoPrestamoClientes}
                onClose={() => setModalInfoPrestamoClientes(false)}
                idpg={idPrestamoGrupal}
            />

            <ModalPagosPrestamoGrupal
                open={modalPpgOpen}
                onClose={() => setModalPpgOpen(false)}
                idpg={idPrestamoGrupal}

            />
        </div>
    )

}

export default RevisarPrestamosGrupal